import template from './contactAssetCommitmentSchedulesList.template.html';

export default {
  template,
  bindings: {
    assetCommitments: '<',
    lenders: '<',
    documents: '<',
    contact: '<',
    onEdit: '&',
    onDelete: '&',
    onReady: '&'
  },
controller: class controller {
    constructor($rootScope, $mdMedia, listServiceNew, assetFinanceService, helperService) {
      'ngInject';
      /*
       * Controller
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.natural = $rootScope.natural;
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.list = new listServiceNew.List();
      ctrl.list.clear();
      ctrl.availableProductTypes = [];

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = function () {
        ctrl.availableProductTypes = assetFinanceService.getAvailableProductTypes({
          isCommercial: true
        });
        ctrl.availableTermInMonths = helperService.getAvailableTermInMonths({
          isRegular: true
        });
        ctrl.assetCommitments = ctrl.assetCommitments || [];
        ctrl.documents = ctrl.documents || [];
        ctrl.lenders = ctrl.lenders || [];
        ctrl.contact = ctrl.contact || [];
        ctrl.list.setData(ctrl.assetCommitments);
        ctrl.list.setOrderBy('asset');
        ctrl.onReady({ list: ctrl.list });
      };

      ctrl.assetCommitmentScheduleEdit = ($event, data) => {
        ctrl.onEdit({ event: $event, data });
      };

      ctrl.assetCommitmentScheduleDelete = ($event, data) => {
        ctrl.onDelete({ event: $event, data });
      };

      ctrl.getLenderDocument = ({ abbr }) => {
        const doc = _.find(
          ctrl.documents,
          (d) => d.lender[0]?.abbr.toLowerCase() === abbr && d.type.indexOf('LOGO') > -1
        );
        return doc?.url || '';
      };

      ctrl.getLenderName = ({ assetCommitment }) => {
        const lender = _.find(
          ctrl.lenders,
          (l) => l?.abbr.toLowerCase() === assetCommitment?.lender
        );
        return lender?.name || assetCommitment?.lenderOtherName || 'N/A';
      };

      ctrl.getFacility = ({ idFacility }) => {
        const facility = _.find(ctrl.availableProductTypes, (p) => p?.id === idFacility);
        return facility?.value || 'N/A';
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      ctrl.$onChanges = (changes) => {
        if (changes.assetCommitments) {
          ctrl.initialize();
        }
      };
    }
  }
};
